

// Fetch all 360° view data for an account in a single request
export const fetchCustomer360Data = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/accounts/${accountId}/360-view`);
    return response.data;
  } catch (error) {
    console.error('Error fetching 360° view data:', error);
    return []; // Return empty array instead of throwing error
  }
};

// Individual data fetching functions for separate components
export const fetchAccountContacts = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/accounts/${accountId}/contacts`);
    return response.data;
  } catch (error) {
    console.error('Error fetching account contacts:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountDeals = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/accounts/deals/${accountId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching account deals:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountCases = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/cases/account/${accountId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching account cases:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountActivities = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get('/activities/', {
      params: {
        parent_table: 'accounts',
        parent_table_id: accountId
      }
    });
    // console.log('response for activities:', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching account activities:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountCommunications = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/accounts/${accountId}/communications`);
    return response.data;
  } catch (error) {
    console.error('Error fetching account communications:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountDocuments = async (accountId, axiosInstance) => {
  const parentTable = 'accounts';
  const parentId = accountId;
  try {
    const response = await axiosInstance.get('/attachments/', {
      params: {
        parent_table: parentTable,
        parent_id: parentId
        // skip: 0,
        // limit: 100,
        // sort_by: 'created_at',
        // sort_order: 'desc'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching account documents:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountOrders = async (accountId, axiosInstance) => {
  try {
    const response = await axiosInstance.get(`/orders/account/${accountId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching account orders:', error);
    return []; // Return empty array instead of throwing error
  }
};

export const fetchAccountInvoices = async (
  accountId,
  axiosInstance,
  { showTravel = false } = {},
) => {
  try {
    // Align with Invoices list visibility: travel tenants must not load legacy
    // sales-order invoices (those detail pages are blocked when travel is on).
    // Backend also matches travel invoices via pax.customer_id / deal account
    // when Invoice.account_id is null.
    const response = await axiosInstance.get('/invoices/', {
      params: {
        account_id: accountId,
        order_kind: showTravel ? 'travel' : 'normal',
      },
    });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Error fetching account invoices:', error);
    return [];
  }
};